
<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading page-heading">
          <div>
            <h2>Wnioski KaiZen</h2>
          </div>
        </div>

        <div class="widget-content">
          <div class="toolbar">
			<select class="form-select form-sm mb-2" style="width: 140px;" v-model="selectedYear" @change="onYearChange">
			  <option v-for="year in availableYears" :key="year" :value="year">
				{{ year }}
			  </option>
			</select>
			<button type="button" class="btn btn-primary" @click="downloadPDF" >
			  Pobierz PDF
			</button>			
            <div class="search-box">
              <span class="search-icon">⌕</span>
              <input
                v-model="search"
                type="search"
                placeholder="Szukaj ..."
                aria-label="Szukaj wniosków"
                @input="onSearchInput"
              />
            </div>
          </div>

          <div class="list-meta">
            <span>
              <span class="online-dot"></span>
              Sortowanie: od najnowszych
            </span>

            <span v-if="wnioski.total">
              Wyświetlanie {{ wnioski.from }}–{{ wnioski.to }}
              z {{ wnioski.total }}
            </span>
          </div>

          <div v-if="pageError" class="notice notice-error" role="alert">
            <span>{{ pageError }}</span>
            <button
              type="button"
              aria-label="Zamknij komunikat"
              @click="pageError = ''"
            >
              ×
            </button>
          </div>

          <div v-if="pageSuccess" class="notice notice-success" role="status">
            <span>{{ pageSuccess }}</span>
            <button
              type="button"
              aria-label="Zamknij komunikat"
              @click="pageSuccess = ''"
            >
              ×
            </button>
          </div>

          <div v-if="records.length" class="table-wrap">
            <table class="kaizen-table">
              <thead>
                <tr>
                  <th>Numer</th>
                  <th>Temat</th>
                  <th>Obszar</th>
                  <th>Autor</th>
                  <th>Data dodania</th>
				  <th>Pliki</th>
                  <th>Tak</th>
                  <th>Nie</th>
                  <th>Nie wiem</th>
                  <th>Status</th>
                  <th>Zmień status</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="record in records" :key="record.id">
                  <td class="number-cell">
                    {{ record.numer }}
                  </td>

                  <td class="topic-cell">
                    {{ record.temat }}
                  </td>

                  <td>
                    {{ record.obszar || "—" }}
                  </td>

                  <td class="author-cell">
                    {{ authorName(record.user) }}
                  </td>

                  <td class="date-cell">
                    {{ formatDate(record.created_at) }}
                  </td>
					<td class="files-cell">
					  <div v-if="record.files && record.files.length" class="file-list">
						<div
						  v-for="file in record.files"
						  :key="file.id"
						  class="file-item"
						>
						  <a
							class="file-link"
							:href="route('kaizen.files.download', {
							  kaizen: record.id,
							  file: file.id
							})"
						  >
							{{ file.name }}
						  </a>
						</div>
					  </div>
					  <span v-else class="no-files">Brak plików</span>
					</td>
                  <td>
                    <button
                      type="button"
                      class="vote-total yes-total"
                      :disabled="Number(record.glosy_tak || 0) === 0"
                      :aria-label="`Pokaż głosy na tak: ${record.glosy_tak || 0}`"
                      @click="toggleDetails(record.id, 'tak')"
                    >
                      {{ record.glosy_tak || 0 }}
                    </button>
                  </td>

                  <td>
                    <button
                      type="button"
                      class="vote-total no-total"
                      :disabled="Number(record.glosy_nie || 0) === 0"
                      :aria-label="`Pokaż głosy na nie: ${record.glosy_nie || 0}`"
                      @click="toggleDetails(record.id, 'nie')"
                    >
                      {{ record.glosy_nie || 0 }}
                    </button>
                  </td>

                  <td>
                    <button
                      type="button"
                      class="vote-total unknown-total"
                      :disabled="Number(record.glosy_nie_wiem || 0) === 0"
                      :aria-label="`Pokaż głosy nie wiem: ${record.glosy_nie_wiem || 0}`"
                      @click="toggleDetails(record.id, 'nie_wiem')"
                    >
                      {{ record.glosy_nie_wiem || 0 }}
                    </button>
                  </td>

                  <td>
                    <span :class="['status', statusClass(record.status)]">
                      <span class="status-dot"></span>
                      {{ statusLabel(record.status) }}
                    </span>
                  </td>

                  <td>
                    <div class="row-actions">
                      <select
                        class="status-select"
                        :value="record.status"
                        :disabled="savingId === record.id"
                        :aria-label="`Zmień status wniosku ${record.numer || record.id}`"
                        @change="changeStatus(record, $event.target.value)"
                      >
                        <option :value="0">Nowy</option>
                        <option :value="1">W trakcie</option>
                        <option :value="2">Zaakceptowano</option>
                        <option :value="3">Zrealizowano</option>
                        <option :value="4">Odrzucony</option>
                      </select>

                      <small
                        v-if="savingId === record.id"
                        class="saving-hint"
                      >
                        Zapisywanie statusu…
                      </small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="empty-state">
            <div class="empty-icon">⌕</div>
            <strong>Nie znaleziono wniosków</strong>

            <p>
              {{ search
                ? "Zmień frazę wyszukiwania."
                : "Nie ma jeszcze wniosków do wyświetlenia." }}
            </p>

            <button
              v-if="search"
              type="button"
              class="btn-outline"
              @click="clearSearch"
            >
              Wyczyść wyszukiwanie
            </button>
          </div>

          <div
            v-if="paginationLinks.length > 3"
            class="pagination-footer"
          >
            <span class="pagination-info">
              Strona {{ wnioski.current_page }} z {{ wnioski.last_page }}
            </span>

            <nav aria-label="Paginacja wniosków">
              <ul class="pagination">
                <li
                  v-for="(link, index) in paginationLinks"
                  :key="`${index}-${link.label}`"
                  :class="{
                    active: link.active,
                    disabled: !link.url,
                  }"
                >
                  <button
                    type="button"
                    class="page-link"
                    :disabled="!link.url"
                    :aria-current="link.active ? 'page' : undefined"
                    @click="goToPage(link.url)"
                    v-html="link.label"
                  ></button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <div
        v-if="selectedRecord"
        class="modal-backdrop"
        @click.self="closeVotesModal"
      >
        <section
          class="duty-modal votes-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="votes-modal-title"
        >
          <header class="modal-header">
            <div>
              <h3 id="votes-modal-title">Oddane głosy</h3>

              <p class="modal-subtitle">
                Wniosek {{ selectedRecord.numer || `#${selectedRecord.id}` }}
                <span class="subtitle-separator">·</span>
                Łącznie {{ totalVotes(selectedRecord) }} głosów
              </p>
            </div>

            <button
              class="close-button"
              type="button"
              aria-label="Zamknij"
              @click="closeVotesModal"
            >
              ×
            </button>
          </header>

          <div class="modal-content">
            <div
              v-if="filteredVotes(selectedRecord).length"
              class="voters-table-wrap"
            >
              <table class="voters-table">
                <thead>
                  <tr>
                    <th>Imię i nazwisko</th>
                    <th>Głos</th>
                    <th>Data głosowania</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="vote in filteredVotes(selectedRecord)"
                    :key="vote.id"
                  >
                    <td class="voter-name">
                      {{ authorName(vote.user) || "—" }}
                    </td>

                    <td>
                      <span :class="['voter-choice', voteClass(vote.vote)]">
                        {{ voteLabel(vote.vote) }}
                      </span>
                    </td>

                    <td>
                      {{ formatDate(vote.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="empty-state modal-empty-state">
              Brak głosów w wybranej kategorii.
            </div>
          </div>
        </section>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";
import { router } from "@inertiajs/vue3";

export default {
  name: "KaiZenHR",

  components: {
    AppLayout,
  },

  props: {
    wnioski: {
      type: Object,
      default: () => ({
        data: [],
        links: [],
        total: 0,
        current_page: 1,
        last_page: 1,
      }),
    },
availableYears: {
  type: Array,
  default: () => [new Date().getFullYear()],
},
    filters: {
      type: Object,
      default: () => ({ search: "" }),
    },

    statusy: {
      type: Object,
      default: () => ({
        0: "Nowy",
        1: "W trakcie",
        2: "Zaakceptowano",
        3: "Zrealizowano",
        4: "Odrzucony",
       }),
    },
  },

  data() {
    return {
      search: this.filters.search || "",
	  	  selectedYear: Number(
  this.filters.year || new Date().getFullYear()
),
      searchTimer: null,
      savingId: null,
      pageError: "",
      pageSuccess: "",
      expandedId: null,
      detailVote: null,
    };
  },

  computed: {
    selectedRecord() {
      if (this.expandedId === null || this.expandedId === undefined) {
        return null;
      }

      return this.records.find(
        record => String(record.id) === String(this.expandedId)
      ) || null;
    },

    records() {
      return this.wnioski?.data || [];
    },

    paginationLinks() {
      return this.wnioski?.links || [];
    },
  },

  watch: {
"filters.year"(value) {
  this.selectedYear = Number(
    value || new Date().getFullYear()
  );
},
  },

  beforeUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  methods: {
  downloadPDF() {
  const url = route("kaizen.hr.pdf", {
    rok: this.selectedYear,
  });

  window.open(url, "_blank");
},
    submitFilters(page = 1) {
  if (this.searchTimer) {
    clearTimeout(this.searchTimer);
  }

  router.post(
    route("kaizen.hr"),
    {
      year: this.selectedYear,
      search: this.search.trim(),
      page,
    },
    {
      preserveState: true,
      preserveScroll: true,
      replace: true,
    }
  );
},
onYearChange() {
  this.pageError = "";
  this.pageSuccess = "";
  this.submitFilters(1);
},
    closeVotesModal() {
      this.expandedId = null;
      this.detailVote = null;
    },

    authorName(user) {
      if (!user) return "";

      if (user.name) return user.name;

      return `${user.first_name || ""} ${user.last_name || ""}`.trim();
    },

    statusLabel(status) {
      return (
        this.statusy?.[Number(status)] ??
        this.statusy?.[String(status)] ??
        "Nieznany"
      );
    },

    statusClass(status) {
      return {
        0: "status-new",
        1: "status-progress",
        2: "status-accept",
        3: "status-done",
        4: "status-rejected",
      }[Number(status)] || "status-default";
    },

    voteLabel(vote) {
      return {
        tak: "Tak",
        nie: "Nie",
        nie_wiem: "Nie wiem",
      }[vote] || vote;
    },

    voteClass(vote) {
      return {
        tak: "choice-yes",
        nie: "choice-no",
        nie_wiem: "choice-unknown",
      }[vote] || "";
    },

    totalVotes(record) {
      return (
        Number(record.glosy_tak || 0) +
        Number(record.glosy_nie || 0) +
        Number(record.glosy_nie_wiem || 0)
      );
    },

    toggleDetails(id, vote = null) {
      const record = this.records.find(
        item => String(item.id) === String(id)
      );

      if (!record) return;

      const counts = {
        tak: Number(record.glosy_tak || 0),
        nie: Number(record.glosy_nie || 0),
        nie_wiem: Number(record.glosy_nie_wiem || 0),
      };

      if (vote !== null && !counts[vote]) return;
      if (vote === null && this.totalVotes(record) === 0) return;

      if (
        String(this.expandedId) === String(id) &&
        this.detailVote === vote
      ) {
        this.closeVotesModal();
        return;
      }

      this.expandedId = record.id;
      this.detailVote = vote;
    },

    filteredVotes(record) {
      const votes = record?.votes || [];

      if (!this.detailVote) {
        return votes;
      }

      return votes.filter(vote => vote.vote === this.detailVote);
    },

onSearchInput() {
  if (this.searchTimer) {
    clearTimeout(this.searchTimer);
  }

  this.searchTimer = setTimeout(() => {
    this.submitFilters(1);
  }, 350);
},

clearSearch() {
  this.search = "";
  this.submitFilters(1);
},

goToPage(url) {
  if (!url) return;

  const parsedUrl = new URL(url, window.location.origin);
  const page = Number(parsedUrl.searchParams.get("page") || 1);

  this.submitFilters(page);
},

    async changeStatus(record, rawStatus) {
      const newStatus = Number(rawStatus);
      const oldStatus = Number(record.status);

      if (newStatus === oldStatus || this.savingId !== null) return;

      this.savingId = record.id;
      this.pageError = "";
      this.pageSuccess = "";

      try {
        const response = await axios.patch(
          route("kaizen.hr.status", record.id),
          { status: newStatus },
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        record.status = Number(response.data.kaizen.status);

        this.pageSuccess =
          response.data.message || "Status został zmieniony.";
      } catch (error) {
        record.status = oldStatus;

        if (error.response?.status === 422) {
          this.pageError = "Wybrano nieprawidłowy status.";
        } else if (error.response?.status === 403) {
          this.pageError = "Nie masz uprawnień do zmiany statusu.";
        } else if (error.response?.status === 404) {
          this.pageError = "Nie znaleziono wniosku.";
        } else {
          this.pageError =
            error.response?.data?.message ||
            "Nie udało się zapisać statusu. Odśwież stronę i sprawdź aktualny stan.";
        }
      } finally {
        this.savingId = null;
      }
    },

    formatDate(value) {
      if (!value) return "—";

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) return "—";

      return new Intl.DateTimeFormat("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },
  },
};
</script>


<style scoped>
.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px 0 24px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 0 14px;
}

.section-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.total-badge {
  padding: 6px 10px;
  border-radius: 20px;
  background: #edf4ff;
}

.search-box {
  display: flex;
  width: min(100%, 440px);
  min-height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 11px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  box-sizing: border-box;
}

.search-box:focus-within {
  border-color: #7da4f5;
  box-shadow: 0 0 0 3px rgb(40 100 215 / 9%);
}

.search-icon {
  flex: 0 0 auto;
}

.search-box input {
  width: 100%;
  min-width: 0;
  padding: 10px 0;
  border: 0;
  outline: 0;
  background: transparent;
  box-sizing: border-box;
}

.list-meta {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 4px 0 15px;
}

.online-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 50%;
  background: #26a269;
}

/* Główna tabela — styl taki jak w pierwszym komponencie */
.table-wrap {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
}

.kaizen-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  text-align: left;
}

.kaizen-table th,
.kaizen-table td {
  padding: 12px;
  border-bottom: 1px solid #edf0f5;
  vertical-align: middle;
  letter-spacing: normal;
  text-transform: none;
}

.kaizen-table th {
  background: #f7f9fc;
  white-space: nowrap;
}

.kaizen-table tbody tr:last-child td {
  border-bottom: 0;
}

.kaizen-table tbody tr {
  transition: background 0.15s;
}

.kaizen-table tbody tr:hover {
  background: #fafcff;
}

.number-cell,
.date-cell {
  white-space: nowrap;
}

.topic-cell {
  min-width: 190px;
  max-width: 320px;
  overflow-wrap: anywhere;
}

.author-cell {
  min-width: 80px;
  max-width: 160px;
  overflow-wrap: anywhere;
}

/* Liczby głosów */
.vote-total {
  min-width: 35px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  font: inherit;
}

.vote-total:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.yes-total {
  border-color: #b7e5ce;
  background: #f0fbf5;
  color: #168258;
}

.yes-total:hover:not(:disabled) {
  border-color: #168258;
  background: #e2f7ec;
}

.no-total {
  border-color: #f0c4c4;
  background: #fff5f5;
  color: #c23939;
}

.no-total:hover:not(:disabled) {
  border-color: #c23939;
  background: #ffebeb;
}

.unknown-total {
  border-color: #d8deea;
  background: #f7f8fb;
  color: #596579;
}

.unknown-total:hover:not(:disabled) {
  border-color: #8795ac;
  background: #edf1f7;
}

/* Status */
.status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 20px;
  white-space: nowrap;
}

.status-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-new {
  background: #eaf1ff;
  color: #2457c5;
}

.status-progress {
  background: #fff3d9;
  color: #996100;
}

.status-accept {
  background: #dbeafe;
  color: #1d4ed8;
}
.status-done {
  background: #e4f7ee;
  color: #168258;
}

.status-rejected {
  background: #ffebeb;
  color: #c23939;
}

.status-default {
  background: #edf0f5;
  color: #596579;
}

/* Zmiana statusu */
.row-actions {
  display: flex;
  min-width: 145px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
}

.status-select {
  width: 100%;
  max-width: 160px;
  min-height: 36px;
  padding: 7px 25px 7px 8px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  color: #33445a;
  font-size: 12px;
}

.status-select:disabled {
  cursor: wait;
  opacity: 0.6;
}

.saving-hint {
  display: block;
  color: #718096;
  font-size: 11px;
}

/* Komunikaty */
.notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px;
  padding: 12px 14px;
  border: 1px solid transparent;
  border-radius: 8px;
}

.notice button {
  border: 0;
  background: transparent;
  cursor: pointer;
}

.notice-error {
  border-color: #f0c7c7;
  background: #fff3f3;
  color: #a92f2f;
}

.notice-success {
  border-color: #bde8d0;
  background: #effaf4;
  color: #176c49;
}

/* Pusty stan */
.empty-state {
  margin-top: 15px;
  padding: 45px 15px;
  border: 1px dashed #dfe6ef;
  border-radius: 10px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 10px;
}

.empty-state strong {
  display: block;
}

.empty-state p {
  margin: 7px 0 15px;
}

.btn-outline {
  padding: 8px 12px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
}

/* Paginacja */
.pagination-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  padding: 18px 4px 4px;
}

.pagination-info {
  color: #718096;
  font-size: 12px;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.page-link {
  display: inline-flex;
  min-width: 34px;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
}

.pagination li.active .page-link {
  border-color: #2864d7;
  background: #2864d7;
  color: #fff;
}

.pagination li.disabled .page-link {
  background: #f7f8fa;
  color: #aab3c0;
  cursor: not-allowed;
}

/* Informacja pod tabelą */
.page-footnote {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
}

.info-icon {
  display: inline-flex;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  align-items: center;
  justify-content: center;
  border: 1px solid #aab5c5;
  border-radius: 50%;
}

/* Modal z głosami */
.modal-backdrop {
  position: fixed;
  z-index: 1050;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  background: rgba(20, 32, 48, 0.55);
}

.duty-modal {
  display: flex;
  width: min(100%, 950px);
  max-height: calc(100vh - 40px);
  flex-direction: column;
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 26px;
  border-bottom: 1px solid #edf0f5;
}

.modal-header h3 {
  margin: 0;
  color: #1d2a3b;
  font-size: 21px;
  font-weight: 750;
}

.modal-subtitle {
  margin: 7px 0 0;
  font-size: 14px;
  overflow-wrap: anywhere;
}

.subtitle-separator {
  padding: 0 4px;
}

.close-button {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: #f2f5f9;
  color: #526176;
  font-size: 25px;
  line-height: 1;
  cursor: pointer;
}

.close-button:hover {
  background: #e7edf5;
}

.modal-content {
  min-height: 0;
  padding: 22px 26px 26px;
  overflow-y: auto;
}

/* Tabela w modalu */
.voters-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
}

.voters-table {
  width: 100%;
  min-width: 460px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  text-align: left;
}

.voters-table th,
.voters-table td {
  padding: 12px;
  border-bottom: 1px solid #edf0f5;
  vertical-align: middle;
  letter-spacing: normal;
  text-transform: none;
}

.voters-table th {
  background: #f7f9fc;
  white-space: nowrap;
}

.voters-table tbody tr:last-child td {
  border-bottom: 0;
}

.voters-table tbody tr:hover {
  background: #fafcff;
}

.voter-name {
  overflow-wrap: anywhere;
}

.voter-choice {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 9px;
  border-radius: 15px;
  font-size: 12px;
  white-space: nowrap;
}

.choice-yes {
  background: #e4f7ee;
  color: #21683a;
}

.choice-no {
  background: #ffebeb;
  color: #b4232c;
}

.choice-unknown {
  background: #edf0f5;
  color: #526176;
}

.modal-empty-state {
  margin-top: 0;
}

/* Responsywność */
@media (max-width: 768px) {
  .page-heading {
    align-items: flex-start;
  }

  .toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .search-box {
    width: 100%;
  }

  .list-meta {
    flex-direction: column;
  }

  .pagination-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .modal-backdrop {
    padding: 10px;
  }

  .duty-modal {
    width: 100%;
    max-height: calc(100vh - 20px);
    border-radius: 14px;
  }

  .modal-header {
    align-items: flex-start;
    padding: 17px 14px;
    gap: 12px;
  }

  .modal-header h3 {
    font-size: 19px;
  }

  .modal-content {
    padding: 17px 14px;
  }

  .voters-table th,
  .voters-table td {
    padding: 11px 9px;
  }

  .page-footnote {
    align-items: flex-start;
  }
}

@media (max-width: 380px) {
  .modal-backdrop {
    padding: 6px;
  }

  .duty-modal {
    max-height: calc(100vh - 12px);
    border-radius: 12px;
  }

  .modal-header {
    padding: 15px 11px;
  }

  .modal-content {
    padding: 14px 11px;
  }

  .close-button {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
  }
}
.files-cell {
  min-width: 180px;
  max-width: 280px;
}

.file-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 10px;
}

.file-link {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  color: #2864d7;
  font-size: 12px;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.file-link:hover {
  text-decoration: underline;
}

.no-files {
  display: block;
  margin-bottom: 10px;
  color: #8793a5;
  font-size: 12px;
}

</style>
